module.exports = __webpack_public_path__ + "static/media/matic-logo-square.4a86581c.svg";